import axiosHttp from "./interceptor.service";

const postClient = (data) => {
  return axiosHttp.post("/feedback/createClient", data);
};

const getClient = (data) => {
  return axiosHttp.get("/feedback/getClient", {
    params: {
      search: data?.search,
      sort: data?.sort,
      limit: data?.limit,
      page: data?.page,
    },
  });
};

const updateClient = (id, data) => {
  return axiosHttp.put(`/feedback/updateClient/${id}`, data);
};

const deleteClient = (id) => {
  return axiosHttp.delete(`/feedback/deleteClient/${id}`);
};

export { postClient, getClient, updateClient, deleteClient };
